import { createContext, useContext, useState, type ReactNode } from "react";

interface PageTitleContextValue {
  title: string;
  setTitle: (title: string) => void;
  showBack: boolean;
  setShowBack: (show: boolean) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | null>(null);

export function PageTitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState("");
  const [showBack, setShowBack] = useState(false);

  return (
    <PageTitleContext.Provider value={{ title, setTitle, showBack, setShowBack }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  const ctx = useContext(PageTitleContext);
  if (!ctx) {
    throw new Error("usePageTitle must be used within a PageTitleProvider");
  }
  return ctx;
}
